import {
  OnboardingSurveyOptionId,
  Survey,
  SurveyAnswer,
  SurveyAnswerContinuationContext,
  SurveyOption,
  SurveyProvider,
} from "@/data/onboarding.data";
import { OnboardingSurveyOption } from "@prisma/client";
import {
  buildSurveyOtherOption,
  buildSurveySelectionOption,
} from "@/components/pages/onboarding/utils/onboarding.utils";
import { getStartingServiceSurvey } from "@/actions/db/survey";
import { useRouter } from "next/navigation";

export const useStartingServiceSurvey = (): SurveyProvider => {
  const mapSurveyOption = (
    surveyOption: OnboardingSurveyOption,
  ): SurveyOption => {
    const id = surveyOption.id as OnboardingSurveyOptionId;

    switch (id) {
      case "starting-service/convert":
        return buildSurveySelectionOption(id, "Convert Vocals");
      case "starting-service/stem-splitter":
        return buildSurveySelectionOption(id, "Split Stems");
      case "starting-service/mastering":
        return buildSurveySelectionOption(id, "Master Tracks");
      case "starting-service/custom-voices":
        return buildSurveySelectionOption(id, "Clone AI Voices");
      case "starting-service/other":
        return buildSurveyOtherOption(id);
      default:
        throw new Error(`Unknown option id: ${surveyOption.id}`);
    }
  };

  const fetchSurvey = async (): Promise<Survey> => {
    const survey = await getStartingServiceSurvey();

    if (!survey) {
      throw new Error(`Starting service survey not found`);
    }

    return {
      title: "What do you want to do with AudioModify?",
      otherTitle: "Can’t find your use case? Tell us what you need",
      options: survey.OnboardingSurveyOptions.map((option) =>
        mapSurveyOption(option),
      ),
      handleSubmitAnswer,
    };
  };

  const getNavigationKeyToStartingService = (id: OnboardingSurveyOptionId) => {
    switch (id) {
      case "starting-service/convert":
        return "/convert";
      case "starting-service/stem-splitter":
        return "/stem-splitter";
      case "starting-service/mastering":
        return "/ai-mastering";
      case "starting-service/custom-voices":
        return "/custom";
      default:
        return "/";
    }
  };

  const handleSubmitAnswer = async (
    answer: SurveyAnswer,
  ): Promise<SurveyAnswerContinuationContext> => {
    return {
      type: "navigate",
      route: getNavigationKeyToStartingService(answer.optionId),
    };
  };

  return { fetchSurvey };
};
